(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-pdp-gallery"] && !Shopify.designMode) return;
  try {
    class PdpGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
      if (!this.track || this.slides.length === 0) return;

      this.thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
      this.dots = [...this.querySelectorAll('[data-gallery-dot]')];
      this.rail = this.querySelector('[data-gallery-thumbs]');
      this.current = this.querySelector('[data-gallery-current]');
      this.index = Number(this.dataset.startIndex) || 0;

      this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.goTo(Number(thumb.dataset.index))));
      this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.step(-1));
      this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.step(1));
      this.track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.step(-1);
        if (event.key === 'ArrowRight') this.step(1);
      });

      // which slide is showing — read from the scroll position on a native
      // swipe. While an arrow/thumb-triggered smooth scroll is in flight the
      // intermediate positions are ignored (they'd flip the counter/height
      // back and forth) until scrollend, or a timeout where scrollend isn't
      // supported.
      this.track.addEventListener(
        'scroll',
        () => {
          if (!this.scrollLock) this.syncFromScroll();
        },
        { passive: true }
      );
      this.track.addEventListener('scrollend', () => {
        this.scrollLock = false;
        this.syncFromScroll();
      });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.fitHeight());
        this.resizeObserver.observe(this.track);
      }

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const mediaId = event?.data?.variant?.featured_media?.id;
          if (!mediaId) return;
          const index = this.slides.findIndex((slide) => Number(slide.dataset.mediaId) === mediaId);
          if (index > -1) this.goTo(index);
        });
      }

      if (this.index > 0) this.goTo(this.index, false);
      else this.setActive(0);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      clearTimeout(this.lockTimer);
      if (typeof this.unsubscribe === 'function') this.unsubscribe();
    }

    step(direction) {
      const count = this.slides.length;
      this.goTo((this.index + direction + count) % count);
    }

    goTo(index, smooth = true) {
      const slide = this.slides[index];
      if (!slide) return;
      clearTimeout(this.lockTimer);
      this.scrollLock = smooth;
      if (smooth) this.lockTimer = setTimeout(() => (this.scrollLock = false), 900);
      this.track.scrollTo({ left: slide.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      this.setActive(index);
    }

    syncFromScroll() {
      const width = this.track.clientWidth;
      if (!width) return;
      const index = Math.round(this.track.scrollLeft / width);
      if (this.slides[index]) this.setActive(index);
    }

    setActive(index) {
      if (index === this.activeIndex) return;
      this.activeIndex = index;
      this.index = index;

      this.thumbs.forEach((thumb, i) => {
        const on = i === index;
        thumb.classList.toggle('is-active', on);
        if (on) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      if (this.current) this.current.textContent = index + 1;

      // pause any video that's no longer on screen
      this.slides.forEach((slide, i) => {
        if (i !== index) slide.querySelectorAll('video').forEach((video) => video.pause());
      });

      // keep the active thumbnail visible inside the rail (without scrolling the page)
      const thumb = this.thumbs[index];
      if (this.rail && thumb && this.rail.scrollHeight > this.rail.clientHeight) {
        this.rail.scrollTo({ top: thumb.offsetTop - (this.rail.clientHeight - thumb.clientHeight) / 2, behavior: 'smooth' });
      }

      this.fitHeight();
    }

    // stage height follows the active photo's own ratio — nothing cropped
    fitHeight() {
      const slide = this.slides[this.index];
      const ratio = slide ? parseFloat(slide.dataset.ratio) : 0;
      const width = this.track.clientWidth;
      if (!ratio || !width) return;
      this.track.style.aspectRatio = 'auto';
      this.track.style.height = `${Math.round(width / ratio)}px`;
    }
  }

  if (!customElements.get('pdp-gallery')) customElements.define('pdp-gallery', PdpGallery);
  } catch(e) { console.error(e); }
})();

})();
